import { render, staticRenderFns } from "./SSSalonListView.vue?vue&type=template&id=4418af86&scoped=true&"
import script from "./SSSalonListView.vue?vue&type=script&lang=js&"
export * from "./SSSalonListView.vue?vue&type=script&lang=js&"
import style0 from "./SSSalonListView.vue?vue&type=style&index=0&id=4418af86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4418af86",
  null
  
)

export default component.exports